import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';

export const StyledButton = styled(Button, {
  fontFamily: '$primary',
  fontSize: '16px !important',
  fontWeight: '590 !important',
  lineHeight: '20px !important',
  padding: '0 !important',
});
